import { forwardRef } from 'react';
import { Mesh } from 'three';

import { Grid as BaseGrid, GridProps as BaseGridProps } from '@react-three/drei';
import { MeshProps } from '@react-three/fiber';

export type GridProps = BaseGridProps & MeshProps;

export const Grid = forwardRef<Mesh, GridProps>((props, ref) => {
  return (
    <BaseGrid
      ref={ref}
      infiniteGrid
      args={[10, 10]}
      cellSize={1}
      cellThickness={0.75}
      fadeDistance={100}
      fadeStrength={0.75}
      position={[0, -0.02, 0]}
      sectionSize={10}
      sectionThickness={1}
      {...props}
    />
  );
});

export default Grid;
